
import React, { useEffect, useRef, useState } from 'react'
import { POST } from 'api/request'
import * as urls from 'api/urls'
import './index.scss'

interface PlaceInputProps {
  value?: string
  error?: string
  placeholder?: string
  setValue: (value: CheckAddressPlace | string) => void
}

interface CheckAddressResponse {
  places: CheckAddressPlace[]
}

interface CheckAddressPlace {
  formattedAddress: string
  addressComponents: AddressComponent[]
  location: Location
  websiteUri: string
  displayName: DisplayName
}

interface AddressComponent {
  longText: string
  shortText: string
  types: string[]
  languageCode: string
}

interface Location {
  latitude: number
  longitude: number
}

interface DisplayName {
  text: string
  languageCode: string
}

const PlaceInput: React.FC<PlaceInputProps> = ({ value, placeholder, error, setValue }) => {
  const [options, setOptions] = useState<CheckAddressPlace[] | null>(null)
  const [open, setOpen] = useState(false)

  const wrapperRef = useRef<HTMLDivElement>(null)
  const timeout = useRef<NodeJS.Timeout | null>(null)


  useEffect(() => {
    const closeHandler = (e: MouseEvent) => {
      !wrapperRef.current?.contains(e.target as Node) && setOpen(false)
    }
    document.addEventListener('click', closeHandler)
    return () => document.removeEventListener('click', closeHandler)
  }, [])

  const getNewOptions = async (value: string) => {
    try {
      const response = await POST<CheckAddressResponse>(urls.findPlace, { body: { text: value } })
      if (response.ok) {
        setOptions(response.data.places)
        setOpen(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div
      ref={wrapperRef}
      className={`address__select__wrapper${error ? ' has__error' : ''}${open && options && options.length > 0 ? ' active' : ''}`}>
      <div className='address__select'>
        <input
          id='input-address'
          value={value || ''}
          placeholder={placeholder || 'Wpisz adres'}
          className={error ? 'has-error' : value ? '--activated' : ''}
          onChange={e => {
            const { value } = e.target
            if (timeout.current) clearTimeout(timeout.current)
            timeout.current = setTimeout(() => getNewOptions(value), 200)
            setValue(value)
          }} />
        {options && options.length > 0 &&
          <i
            className={`icon icon--arrow-${open ? 'up' : 'down'}`}
            onClick={e => {
              e.stopPropagation()
              setOpen((prev) => !prev)
            }}
          />
        }
      </div>
      {options && <div className='address__select__dropdown'>
        <ul className='address__select__dropdown__items'>
          {options.map((item, idx) =>
            <li
              key={idx}
              className='address__select__dropdown__item'
              onClick={() => {
                setValue(item)
                setOpen(false)
              }}>
              <div>{item.displayName.text}</div>
              <div>{item.formattedAddress}</div>
            </li>
          )}
        </ul>
        <div className='address__select__provider'>Powered by Google</div>
      </div>}
    </div>
  )
}

export default PlaceInput